import _ from 'lodash';

import * as api from '../../api';

import Enum from './Enum';
import { useTranslation } from 'react-i18next';
import { getOptionsFromRecord } from '../utils';
import { isEnumMember } from 'common/dist/utils/types';

interface Props {
  navigateToNextPage: () => Promise<void>;
  languageOptions: api.Language.Language[];
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  useAlternateEnum: boolean;
  value: string;
}

export function LanguageInput({
  navigateToNextPage,
  languageOptions,
  saveFieldValue,
  updateFieldValue,
  useAlternateEnum,
  value,
}: Props) {
  const { t } = useTranslation();
  const filteredOptionsMap = _.pick(api.Language.languageMap, languageOptions);
  const displayOptions = getOptionsFromRecord(filteredOptionsMap, t);
  const localPreferredLanguage = localStorage.getItem('preferredLanguage');
  const userPreferredLanguage =
    isEnumMember(languageOptions, localPreferredLanguage) &&
    localPreferredLanguage;
  if (!value && userPreferredLanguage) {
    updateFieldValue(userPreferredLanguage);
  }
  return (
    <Enum
      value={value}
      options={displayOptions}
      onChange={async (option) => {
        updateFieldValue(option);
        await saveFieldValue(option);
        if (useAlternateEnum) navigateToNextPage();
      }}
      useAlternateEnum={useAlternateEnum}
    />
  );
}
